document.addEventListener("DOMContentLoaded", function() {
    const scrollers = document.querySelectorAll(".logos__scroller");
    if (!scrollers.length) return; // Exit if no scrollers found

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        addAnimation();
        window.addEventListener('resize', handleResize);
    }

    function addAnimation() {
        console.log('Running addAnimation function');
        scrollers.forEach((scroller) => {
            const scrollerInner = scroller.querySelector('.logos__list');
            if (!scrollerInner) {
                console.error('Logo list not found in scroller');
                return;
            }
            
            const scrollerContent = Array.from(scrollerInner.children); // copy elements
            if (!scrollerContent.length) {
                console.error('No logo items found in list');
                return;
            }
            
            // Calculate the total width of all logos
            const totalLogosWidth = scrollerContent.reduce((totalWidth, logo) => totalWidth + logo.clientWidth + convertRemToPixels(3.5), 0);
            console.log('Total logos width: ' + totalLogosWidth + 'px');
            
            // Calculate the visible width of the scroller
            const scrollerWidth = scroller.clientWidth;
            console.log('Scroller width: ' + scrollerWidth + 'px');
            
            if (totalLogosWidth > scrollerWidth) {
                console.log('Enabling animation (totalLogosWidth > scrollerWidth)');
                scroller.setAttribute('data-animated', true);
                scroller.style.setProperty("--_logo-scroll-duration", `${scrollerContent.length * 8}s`); // keep the same amount of time each logo is shown by scaling with number of logos
                
                // Remove any previously duplicated items before adding new ones
                removeDuplicatedItems(scrollerInner);

                // Duplicate the logos to allow for seamless scrolling
                const fragment = new DocumentFragment();
                scrollerContent.forEach((item) => {
                    const duplicatedItem = item.cloneNode(true);
                    duplicatedItem.setAttribute('aria-hidden', true);
                    fragment.appendChild(duplicatedItem);
                });
                
                scrollerInner.appendChild(fragment);
            } else {
                scroller.removeAttribute('data-animated');
                removeDuplicatedItems(scrollerInner); // Ensure any duplicated items are removed if no animation is needed
            }
        });
    }

    function handleResize() {
        // Re-evaluate on resize
        scrollers.forEach((scroller) => {
            const scrollerInner = scroller.querySelector('.logos__list');
            if (scrollerInner) {
                removeDuplicatedItems(scrollerInner);
                addAnimation();
            }
        });
    }

    function removeDuplicatedItems(scrollerInner) {
        const duplicatedItems = scrollerInner.querySelectorAll('[aria-hidden="true"]');
        duplicatedItems.forEach(item => item.remove());
    }

    // Utility function to convert rem to pixels
    function convertRemToPixels(rem) {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

    // Check if images are loaded
    const images = document.querySelectorAll('.logos__list img');
    if (images.length === 0) return; // No images to process
    
    let loadedImages = 0;
    let allImagesLoaded = true;
    
    // First check if all images are already loaded
    images.forEach(img => {
        if (img.complete) {
            loadedImages++;
        } else {
            allImagesLoaded = false;
            img.onload = () => {
                loadedImages++;
                if (loadedImages === images.length) {
                    addAnimation(); // Call animation when all images are loaded
                }
            };
            
            // Add error handler in case image fails to load
            img.onerror = () => {
                loadedImages++;
                if (loadedImages === images.length) {
                    addAnimation(); // Call animation even if some images fail
                }
            };
        }
    });
    
    // If all images were already loaded, run the animation now
    if (allImagesLoaded) {
        addAnimation();
    }
    
    // Set a fallback timer in case something goes wrong with image loading
    setTimeout(function() {
        if (!document.querySelector('.logos__scroller[data-animated="true"]')) {
            console.log('Logo animation fallback triggered');
            addAnimation();
        }
    }, 3000); // 3 second fallback
}); 